import { __awaiter, __decorate } from "tslib";
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import CollapsibleForm, { ClassNames as CollapsibleFormClassNames } from '@slickdeals/blueprint-twig/javascript/components/collapsibleForm';
import { ClassNames as InlineFormClassNames } from '@slickdeals/blueprint-twig/javascript/components/inlineForm';
import { ClassNames as TextAreaClassNames } from '@slickdeals/blueprint-twig/javascript/components/textArea';
import BlueprintComponent from '@slickdeals/blueprint-twig/javascript/core/blueprintComponent';
import '@slickdeals/blueprint-twig/javascript/patterns/avatarImage';
import '../../scss/patterns/inlineReply.scss';
/** The name of the module */
export const name = 'InlineReply';
/** ClassNames used for this module */
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-p-inlineReply";
    ClassNames["JavaScript"] = "js-inlineReply";
})(ClassNames || (ClassNames = {}));
let QuestionAndAnswer = class QuestionAndAnswer extends BlueprintComponent {
    constructor(options) {
        super(name, options);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.init.call(this);
            this.element = yield BlueprintComponent.loadElement(name, this.options);
            if (this.options.useCollapsibleForm) {
                // Create and init the collapsible form
                this.initCollapsibleForm();
            }
        });
    }
    /**
       * Creates the CollapsibleForm instance for the module
       * Builds all dependencies manually
       */
    initCollapsibleForm() {
        // Gets the collapsibleForm id to hydrate the TS with
        const collapsibleFormId = this.element.querySelector(`.${CollapsibleFormClassNames.JavaScript}`).id;
        // Gets the inlineForm element
        const inlineFormElement = this.element.querySelector(`.${InlineFormClassNames.JavaScript}`);
        // Gets the cancel button within the inlineReplyElement
        const inlineFormCancelButton = inlineFormElement.querySelector(`.${InlineFormClassNames.CancelButton}`);
        // Creates a new collapsibleForm instance
        this.collapsibleForm = new CollapsibleForm({
            id: collapsibleFormId,
            additionalTriggers: inlineFormCancelButton,
        });
        this.collapsibleForm.subscribe((visibilityData) => {
            if (visibilityData.targetVisibility) {
                const textArea = inlineFormElement.querySelector(`.${TextAreaClassNames.JavaScript}`);
                textArea.focus();
            }
        });
    }
};
QuestionAndAnswer = __decorate([
    injectable(name)
], QuestionAndAnswer);
export default QuestionAndAnswer;
/** Add ReportButton component in the hydration queue */
BlueprintComponent.instantiate(name);
